<template>
  <div class="search communitytopic">
    <header style="padding-right: 0.11rem;">
      <form action="/">
        <van-search
          v-model="searchValue"
          placeholder="搜索话题"
          clearable
          maxlength="32"
          @search="search"
          v-focus="isShow"
        />
      </form>
      <!--<span @click="cancel">取消</span>-->
    </header>
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              @on-refresh="onRefresh"
              @on-infinite="onInfinite"
              class="my_scroller"
              ref="my_scroller"

    >

      <div class="content">
        <ul>
          <li class="f14" v-for="item of list" @click="clickFn(item)">{{item.subject}} <span class="f13" v-if="!item.subjectid">创建新话题</span></li>
        </ul>
      </div>
    </Scroller>
  </div>
</template>

<script>
import { customRequestAjax } from '@/axiosApi'
import Scroller from '../common/Scroller'
import { isWeixin, fenxiang } from '../../assets/common/js/config'
export default {
  name: 'communityTopic',
  components: {
    Scroller
  },
  data () {
    return {
      isShow: true,
      searchValue: '',
      list: [],
      nowPage: 0,
      refresh: false,
      loading: false,
      finished: false
    }
  },
  mounted: function () {
    if (this.$store.state.chooseTopic && this.$store.state.chooseTopic.subject) {
      this.searchValue = this.$store.state.chooseTopic.subject
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!sessionStorage.askPositon || (from.path == '/' && from.name != 'homePage')) { // 当前页面刷新不需要切换位置
      sessionStorage.askPositon = ''
      next(vm => {
        if (isWeixin()) fenxiang({path: 'communitytopic'})
        if (vm.$store.state.chooseTopic && vm.$store.state.chooseTopic.subject) {
          vm.searchValue = vm.$store.state.chooseTopic.subject
        }
        vm.refresh = false
        vm.loading = false
        vm.finished = false
        vm.pagesize = 20
        vm.nowPage = 0
        vm.list = []
      })
    } else {
      next(vm => {
        if (isWeixin()) fenxiang({path: 'communitytopic'})
        if (vm.$store.state.chooseTopic && vm.$store.state.chooseTopic.subject) {
          vm.searchValue = vm.$store.state.chooseTopic.subject
        }
        vm.refresh = false
        vm.loading = false
        vm.finished = false
        vm.pagesize = 20
        vm.nowPage = 0
        vm.list = []
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    this.loading = true
    next()
  },
  watch: {
    searchValue: function () {
      this.nowPage = 0
      this.onInfinite()
    }
  },
  methods: {
    getData: function () {
      var that = this
      var url = 'Wxmall/Community/searchTopic'
      url = url + '?type=1&pageno=' + this.nowPage + '&pagesize=' + this.pagesize + '&keywords=' + this.searchValue
      customRequestAjax(url)
        .then(function (res) {
          if (res.data.code == 200) {
            if (that.nowPage == 1) {
              that.list = []
              that.refresh = false
              if (!res.data.itemlist.length && that.searchValue != '') {
                that.list = [{
                  subjectid: '',
                  subject: that.searchValue
                }]
              }
            }
            that.list = that.list.concat(res.data.itemlist)
            that.loading = false
            if (res.data.itemlist.length < that.pagesize) {
              that.finished = true
            } else {
              that.finished = false
            }
          }
        })
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      var that = this
      that.nowPage++
      that.getData()
    },
    clickFn: function (items) {
      this.$store.commit('CHOOSE_TOPIC', items)
      console.log('communityTopic.vue', this.$store.state.chooseTopic)
      if (items.productlist && items.productlist.length > 0) {
        this.$store.commit('CHOOSE_CROSS_SELL_PRODUCT_ITEM', items.productlist)
      }
      this.$router.go(-1)
      // this.$router.replace({
      //   path: '/communityevaluation',
      //   query: {
      //     type: 'crosscell',
      //     id: this.$route.query.id
      //   }
      // })
    },
    cancel: function () {
      this.$router.go(-1)
    },
    search: function () {
      if (this.searchValue) {
        this.nowPage = 0
        this.onInfinite()
      } else {
        // this.$toast('请正确输入查询内容')
      }
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.children[0].children[0].children[1].children[0].children[0].focus()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.communitytopic {
  header {
    padding-left: 0.11rem;
    background: #fff;
    position: relative;
    z-index: 1;
  }
  .content {
    ul {
      background: #ffffff;
      margin: 0.1rem 0.11rem;
      border-radius: 0.04rem;
      li {
        background: url(/static/images/community/community-topic-selected.png) no-repeat left center;
        background-size: 0.18rem 0.18rem;
        height: 0.5rem;
        line-height: 0.5rem;
        margin: 0 0.11rem;
        position: relative;
        padding-left: 0.22rem;
        display: flex;
        justify-content: space-between;
        span {
          color: #666666;
        }
        &:after {
          content: '';
          display: block;
          background: #D8D8D8;
          height: 0.005rem;
          width: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community/communityTopic.vue